<template>
  <div class="affix-panel">
    <div>
      <a :href="$ComDomain.Modules.mycart">
    <Badge class="badge" :count="$store.state.cartList.length">
      <i class="bg-success"></i>
    </Badge>
    </a>
    </div>
    <div class="phone">
      <i class="bg-success"></i>
      <span class="bg-success">010-52167830</span>
    </div>
    <div class="contact">
      <i class="bg-success" @click="$store.commit('service', {type: 'QQ'})"></i>
    </div>
<!--    <div class="code">
      <i class="bg-success"></i>
    </div>-->
    <BackTop class="back-top" :height="0">
      <i class="top bg-success"></i>
    </BackTop>
  </div>
</template>
<script>
import { Badge, Affix, BackTop } from 'iview'

export default {
  name: 'AffixFuns',
  data() {
    return {}
  },
  watch: {
    '$store.getters.isLogined': {
      handler(value) {
        this.$store.commit('getCartList')
      },
      immediate: true
    }
  },
  components: {
    Badge,
    Affix,
    BackTop
  }
}

</script>
<style scoped lang="less">
@width: 60px;
@height: 60px;

.affix-panel {
  width: @width;
  height: @height * 4;
  background: #000 url("~commons/style/images/affix_tools2.png") no-repeat;
  overflow: visible;
  position: fixed;
  top: 101px;
  right: 0;
  z-index: 500;

  div {
    height: @height;
    line-height: @height;
    font-size: 26px;
    color: #fff;
    cursor: pointer;
    overflow: visible;
    position: relative;

    i {
      display: block;
      height: @height;
      background: url("~commons/style/images/affix_tools2.png") no-repeat;
      opacity: 0;
      padding: 0;
      transition: opacity 0s 0.2s;
      position: relative;
      z-index: 10;
    }

    &.phone {
      i {
        background-position: right -@height * 1;
      }

      span {
        height: 60px;
        white-space: nowrap;
        border-radius: 15px 0 0 15px;
        padding: 0 80px 0 25px;
        transition: right 0.3s;
        position: absolute;
        top: 0;
        right: -350px;
      }
    }

    &.contact i {
      background-position: right -@height * 2;
    }

    &.code i {
      background-position: right -@height * 3;
    }

    .top {
      background-position: right -@height * 3;
    }

    &:hover {
      i {
        opacity: 1;
      }
    }

    &.phone:hover span {
      right: 0;
    }

    .badge {
      display: block;

      sup {
        font-size: 13px;
        top: 8px;
        right: 12px;
        box-shadow: none;
      }
    }
  }

  .back-top {
    position: static;
  }
}

</style>



// WEBPACK FOOTER //
// src/commons/components/layout/AffixFuns.vue